import { Outlet, createRootRoute } from "@tanstack/react-router";
import React, { Suspense } from "react";
import { PostHogProvider } from "posthog-js/react";
import { OrganizationProvider } from "../contexts/OrganizationContext";

const loadDevtools = () =>
  Promise.all([
    import("@tanstack/react-router-devtools"),
    import("@tanstack/react-query-devtools"),
  ]).then(([routerDevtools, reactQueryDevtools]) => {
    return {
      default: () => (
        <>
          <routerDevtools.TanStackRouterDevtools />
          <reactQueryDevtools.ReactQueryDevtools />
        </>
      ),
    };
  });

const TanStackDevtools =
  process.env.NODE_ENV === "production" ? () => null : React.lazy(loadDevtools);

export const Route = createRootRoute({
  component: () => (
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_PROJECT_TOKEN!}
      options={{
        // First-party: '/ingest' is same-origin with the dashboard. Traefik
        // reverse-proxies /ingest -> PostHog (traefik/dynamic/posthog.yml) so
        // ad/tracking blockers can't sever analytics. `npm run dev` proxies the
        // same path via vite.config.ts.
        api_host: '/ingest',
        ui_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST || 'https://eu.posthog.com',
        defaults: '2026-01-30',
        capture_exceptions: true,
        debug: import.meta.env.DEV,
      }}
    >
      <OrganizationProvider>
        <Outlet />
        <Suspense>
          <TanStackDevtools />
        </Suspense>
      </OrganizationProvider>
    </PostHogProvider>
  ),
});
